import { createAction } from '@reduxjs/toolkit';

export const getMyPeerReviewsData = createAction<void>('myPeerReviewsPage/getMyPeerReviews');
